export const Inputs = [
    {
      id: "company",
      type: "text",
      placeholder: "Company Name",
      
    },
];